// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ke-0";
export var fileCarousel = "_ke-2";
export var removeFileButton = "_ke-1";